import { upQuestionApi } from './service';
import { Effect, history } from 'umi';
import { Reducer } from '@@/plugin-dva/connect';
import {
  collectionsDeleteApi,
  collectionsPostApi,
  questionApi,
} from '@/pages/questionBank/subject/service';
import { goBack } from '@/utils/bridge';

export interface AnswerType {
  userAnswer: userAnswerObject[];
  duration: number;
  score: number;
  currectScore: number;
  totalScore: number;
  right_count: number;
  total_count: number;
  exam_id: number;
  title: string;
  paper_id: string;
}

export interface userAnswerObject {
  question_id: string;
  correct: boolean;
  part_id: number;
  analyzing: string;
  answer: string[];
  answers: string[];
  collected: boolean;
  diff_level: string;
  id: number;
  record?: {
    answers: string[];
    correct?: number;
  };
  options: {
    id: number;
    question_id: string;
    option: string;
    content: string;
    is_right: number;
  }[];
  score: number;
  tags: string;
  title: string;
  type: number;
  material?: {
    content: string;
    id: number;
    key_words: string;
  };
}

export interface ModelType {
  namespace: string;
  state: AnswerType;
  effects: {
    fetchQuestion: Effect;
    fetchUserAnswers: Effect;
    fetchCollections: Effect;
  };
  reducers: {
    saveChange: Reducer;
    userAnSave: Reducer;
    collectionChange: Reducer;
  };
}

const Model: ModelType = {
  namespace: 'answer',

  state: {
    userAnswer: [],
    duration: 0,
    score: 0,
    totalScore: 0,
    currectScore: 0,
    right_count: 0,
    total_count: 0,
    exam_id: 0,
    title: '',
    paper_id: '',
  },

  effects: {
    *fetchQuestion({ payload }, { call, put }) {
      const response = yield call(questionApi, payload);
      yield put({
        type: 'saveChange',
        payload: {
          ...response,
          index: payload.questionIndex,
        },
      });
    },
    *fetchCollections({ payload }, { call, put }) {
      const response = yield call(
        payload.isDel ? collectionsDeleteApi : collectionsPostApi,
        payload,
      );
      if (response && response.error_code === 0) {
        yield put({
          type: 'collectionChange',
          payload: {
            ...response,
            index: payload.questionIndex,
            isDel: payload.isDel,
          },
        });
      }
    },
    *fetchUserAnswers({ callback, payload }, { call, put }) {
      const response = yield call(upQuestionApi, payload);
      if (response && response.error_code === 0) {
        yield put({
          type: 'userAnSave',
          payload: {
            ...response,
            paper_id: payload.paper_id,
          },
        });
        let url = '/questionBank/submitAnswers';
        if (payload.type === 'native') url += '?type=native';
        history.replace(url);
      } else if (
        response &&
        response.error_code > 0 &&
        response.error_code < 1007
      ) {
        goBack();
      }
    },
  },
  reducers: {
    saveChange(state, { payload }) {
      const data: any = [...state.userAnswer];
      const dataIndex = payload.index;
      data[dataIndex - 1] = {
        ...data[dataIndex - 1],
        ...payload.data,
      };
      if (dataIndex - 2 > 0) {
        data[dataIndex - 3] = {
          question_id: data[dataIndex - 3].question_id,
          part_id: data[dataIndex - 3].part_id,
          score: data[dataIndex - 3].score,
          id: data[dataIndex - 3].id,
          correct: data[dataIndex - 3].correct,
          record: {
            ...data[dataIndex - 3].record,
          },
          type: data[dataIndex - 3].type,
        };
      }
      if (dataIndex + 2 >= payload.length) {
        data[dataIndex + 2] = {
          question_id: data[dataIndex + 3].question_id,
          part_id: data[dataIndex + 3].part_id,
          score: data[dataIndex + 3].score,
          id: data[dataIndex + 3].id,
          correct: data[dataIndex + 3].correct,
          record: {
            ...data[dataIndex + 3].record,
          },
          type: data[dataIndex + 3].type,
        };
      }
      return {
        ...state,
        userAnswer: data,
      };
    },
    userAnSave(state, { payload }) {
      return {
        ...state,
        userAnswer: payload.data.userAnswer,
        duration: payload.data.duration,
        totalScore: payload.data.totalScore,
        currectScore: payload.data.currectScore,
        right_count: payload.data.right_count,
        total_count: payload.data.total_count,
        exam_id: payload.data.exam_id,
        title: payload.data.title,
        paper_id: payload.data.paper_id,
      };
    },
    collectionChange(state, { payload }) {
      const data: any = [...state.userAnswer];
      const dataIndex = payload.index - 1;
      data[dataIndex].collected = !payload.isDel;
      return {
        ...state,
        data: data,
      };
    },
  },
};

export default Model;
